import React from 'react'
import "../articles.css"

import panels from "../../../../assets/images/articles/panels.jpg"
import { BylinePS, Published } from "../.."

export default function Article9Doc() {


  return (
    <div className='emas__articles'>
      <div className='emas__articles-container'>
          <img className="emas__articles-container_headImage" src={panels} alt="bladerow"></img>
          <div className='emas__articles-container_photo'>
            <i >Photo by Pixabay: https://www.pexels.com/photo/blue-solar-panel-board-356036/</i>
          </div>
          <h1>Our submission to the review of the reserve capacity mechanism</h1>
          <div className='emas__articles-container_publish'>
            <p></p>
          </div>
          <div className='emas__articles-container_body'>
            <p>May 2023</p>
            <p>Click <a href= 'https://www.wa.gov.au/system/files/2023-06/emas-rcmr-submission-stage_2.pdf' >here</a> to go to the EPWA website for our submission to the review of the capacity mechanism.  </p>
          </div>         
          <Published />
      </div>
  </div>
  )
}
